export type Calendar = "gregorian" | "thai-buddhist-era";

const yearOffsets = { gregorian: 0, "thai-buddhist-era": 543 };

export function expandYear(
  year: string,
  when: "past" | "near-future" | "future",
  calendar: Calendar = "gregorian"
): string {
  const yearNumber = Number(year);
  if (
    year.trim().length === 0 ||
    !Number.isFinite(yearNumber) ||
    yearNumber < 0 ||
    yearNumber >= 1000
  ) {
    return year;
  }

  const currentYear = new Date().getFullYear() + yearOffsets[calendar];
  const currentCentury = Math.floor(currentYear / 100) * 100;
  const currentMillenium = Math.floor(currentYear / 1000) * 1000;

  if (yearNumber >= 100) {
    return String(currentMillenium + yearNumber);
  }

  if (when === "past" && currentCentury + yearNumber > currentYear) {
    return String(yearNumber + currentCentury - 100);
  }

  if (when === "future" && currentCentury + yearNumber < currentYear) {
    return String(yearNumber + currentCentury + 100);
  }

  return String(yearNumber + currentCentury);
}

export function zeroPad(value: string, minSize: number) {
  const pad = "0".repeat(Math.max(0, minSize - value.length));
  return `${pad}${value}`;
}

function parseYMD(value: string): [number, number, number] {
  const numbers = value.split("-").map(Number);
  return [numbers[0] || 0, numbers[1] || 0, numbers[2] || 0];
}

function formatYMD(year: number, month: number, day: number): string {
  return `${zeroPad(String(year), 4)}-${zeroPad(String(month), 2)}-${zeroPad(
    String(day),
    2
  )}`;
}

export function calendarToGregorian(value: string, calendar: Calendar) {
  const [year, month, day] = parseYMD(value);
  return formatYMD(year - yearOffsets[calendar], month, day);
}

export function gregorianToCalendar(
  value: string | undefined,
  calendar: Calendar
) {
  if (!value) {
    return "--";
  }
  const [year, month, day] = parseYMD(value);
  return formatYMD(year + yearOffsets[calendar], month, day);
}
